<script lang="ts">
  import SectionVirementWaitedList from '@/generated/sections/SectionVirementWaitedList.vue';
  import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
  import { ColumnFilter, ListChoix } from '@/generated/classes/ListData';
  import Transaction from '@/extend/classes/Transaction';
  import { defineComponent } from "vue";

  export default defineComponent({
    extends: SectionVirementWaitedList,
    name: 'SectionVirementWaitedListExtend',
    components: {},
    data () {
      return {
        transaction: new Transaction(),
      };
    },
    computed: {
      canAdd (): boolean {
        return false;
      },
      headers (): any {
        return [
          { text: "Date de demande", value: 'dateTransaction', cellClass: '', sortable: true },
          { text: "Emetteur", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Référence", value: 'reference', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },
      pageLimit(): number {
        return 5;
      }
    },
    methods: {
      canUpdate (transaction: Transaction): boolean {
        return false;
      },
      defaultFilter (): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.VIREMENT_RECU;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "statut";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionStatuts.WAITED;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      mdiAction (transaction: Transaction): string {
        return 'fas fa-landmark';
      },
      hasAction (transaction: Transaction): boolean {
        return transaction.bankId == 0;
      },
      execAction (transaction: Transaction): void {
        this.actionProgress = true;
        Transaction.rapproche(transaction).then(() => {
          this.actionProgress = false;
        }).catch(() => {
          this.actionProgress = false;
        });
      },
    },
  });
</script>